module.exports = __webpack_public_path__ + "tables/media/Maps_filled.85c0a89d.svg";